import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'

const useStyles = makeStyles(theme => ({
  status: {
    borderRadius: 4,
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: theme.spacing(4.5),
    paddingBottom: theme.spacing(0.5),
    paddingLeft: theme.spacing(2.25),
    paddingRight: theme.spacing(2.25),
    paddingTop: theme.spacing(0.5),

    [theme.breakpoints.up('sm')]: {
      minHeight: theme.spacing(5.5),
      paddingBottom: theme.spacing(1),
      paddingTop: theme.spacing(1),
    },
  },
}))

function ContainedStatus({ backgroundColor, className, color, children }) {
  const classes = useStyles()

  return (
    <Box
      color={color}
      bgcolor={backgroundColor}
      className={clsx(classes.status, className)}
    >
      {children}
    </Box>
  )
}

function OutlinedStatus({ borderColor, className, color, children }) {
  const classes = useStyles()

  return (
    <Box
      border={1}
      borderColor={borderColor}
      color={color}
      className={clsx(classes.status, className)}
    >
      {children}
    </Box>
  )
}

const variants = {
  contained: ContainedStatus,
  outlined: OutlinedStatus,
}

export default function Status({ children, variant = 'contained', ...props }) {
  const Component = variants[variant] || ContainedStatus

  return (
    <Component {...props}>
      <Typography variant="body2">{children}</Typography>
    </Component>
  )
}
